<template>
  <div>
    <div v-meta="{title, keywords, description}" :key="metaKey"></div>

    <div v-if="goods.cats && goods.cats.length">
      <a href="/">首页</a>
      <span v-for="cat in goods.cats" :key="cat.cat_id">
        &gt; <a :href="'/goodsList?cat_id=' + cat.cat_id">{{cat.name}}</a>
      </span>
      <span> &gt; {{goods.title}}</span>
    </div>

    <h1>{{goods.title}}</h1>
    <p v-if="goods.remark">{{goods.remark}}</p>

    <div v-if="goods.brand_name">品牌：<span>{{goods.brand_name}}</span></div>
    <div v-if="goods.unit">单位：<span>{{goods.unit}}</span></div>

    <div v-for="spec in goods_specs" :key="spec.spec_name">
      <span>{{spec.spec_name}}：</span>
      <span v-for="(item, i) in spec.items" :key="i">
        {{item.item_value}}<span v-if="i < spec.items.length - 1"> / </span>
      </span>
    </div>

    <img v-if="goods.images && goods.images[0]" :src="goods.images[0]" :alt="goods.title">

    <div v-if="goods.content" v-html="goods.content"></div>
  </div>
</template>

<script>
export default {
  name: 'GoodsSeoPage',
  data () {
    return {
      goods: {},
      goods_specs: [],
      title: '',
      keywords: '',
      description: '',
      metaKey: 0
    }
  },
  mounted () {
    const goods_id = this.$route.query.goods_id
    if (!goods_id) {
      document.dispatchEvent(new Event('prerender-trigger'))
      return
    }
    this.$.http
      .post('goods/seo-detail', { goods_id }, '', false, false)
      .then(res => {
        const d = res && res.data
        if (!d || !String(d.title || '').trim()) {
          throw new Error('goods/seo-detail 未返回有效商品标题')
        }
        this.goods = d
        this.goods_specs = d.goods_specs || []
        const catName = ((d.cats || [])[1] || (d.cats || [])[0] || {}).name || ''
        this.title = `${d.title} - ${catName} - 上海畅为`
        this.keywords = `${d.keywords || ''} - 上海畅为`
        this.description = `${d.remark || ''} - 上海畅为`
        this.metaKey++
        if (window.__PRERENDER_INJECTED) {
          console.log(`[Prerender] goods-detail-ready goods_id=${goods_id}`)
        }
        document.dispatchEvent(new Event('prerender-trigger'))
      })
      .catch((error) => {
        if (window.__PRERENDER_INJECTED) {
          const info = error && error.status !== undefined
            ? `HTTP ${error.status} ${error.statusText || ''}`
            : (error && error.message ? error.message : String(error || 'unknown error'))
          console.error(`[Prerender] goods-detail-failed goods_id=${goods_id}: ${info}`)
        }
        document.dispatchEvent(new Event('prerender-trigger'))
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/GoodsSeoPage.vue